import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { 
  FacebookShareButton, 
  FacebookIcon, 
  TwitterShareButton, 
  TwitterIcon, 
  WhatsappShareButton, 
  WhatsappIcon, 
  LinkedinShareButton, 
  LinkedinIcon 
} from 'react-share';

function App() {
  const [lang, setLang] = useState("en");

  const t = {
    en: {
      siteTitle: "The New Administrative Capital Consultancy TNACC",
      seoTitle: "TNACC - Real Estate Consultancy in Egypt's New Administrative Capital",
      seoDesc: "TNACC Real Estate Consultancy – Trusted guidance for investments in Egypt's New Administrative Capital. Premium projects, accurate pricing and expert consultancy.",
      intro: "Explore top opportunities in the New Administrative Capital. TNACC provides trusted guidance for investments in Egypt's premier real estate projects.",
      consultationTitle: "Get Your Free Consultation Now!",
      name: "Name",
      mobile: "Mobile Number",
      message: "Message",
      send: "Send",
      or: "OR Contact Us On WhatsApp",
      share: "Share",
      links: {
        facebook: "Facebook",
        instagram: "Instagram",
        youtube: "YouTube",
        tiktok: "TikTok",
        threads: "Threads",
        snapchat: "Snapchat",
        x: "X"
      }
    },

    ar: {
      siteTitle: "شركة استشارات العاصمة الإدارية الجديدة TNACC",
      seoTitle: "TNACC - الاستشارات العقارية في العاصمة الإدارية الجديدة",
      seoDesc: "TNACC للاستشارات العقارية – إرشاد موثوق لاستثمارات العاصمة الإدارية الجديدة. أفضل المشاريع، أسعار دقيقة، وخبرة احترافية.",
      intro: "اكتشف أفضل فرص الاستثمار في العاصمة الإدارية الجديدة. تقدم TNACC إرشاداً موثوقاً للاستثمار في أهم مشروعات مصر.",
      consultationTitle: "احصل على استشارتك المجانية الآن!",
      name: "الاسم",
      mobile: "رقم الموبايل",
      message: "الرسالة",
      send: "إرسال",
      or: "أو تواصل معنا عبر واتساب",
      share: "مشاركة",
      links: {
        facebook: "فيسبوك",
        instagram: "إنستجرام",
        youtube: "يوتيوب",
        tiktok: "تيك توك",
        threads: "ثريدز",
        snapchat: "سناب شات",
        x: "إكس"
      }
    }
  };

  const shareUrl = "https://tnacc.netlify.app";

  return (
    <>
      <Helmet>
        <title>{t[lang].seoTitle}</title>
        <meta name="description" content={t[lang].seoDesc} />
      </Helmet>

      <div
        className="app-container"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL + '/images/background.gif'})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          minHeight: '100vh',
          width: '100%',
          overflowX: 'hidden',
          color: 'white',
          fontFamily: 'Arial, sans-serif',
          padding: '20px',
          boxSizing: 'border-box',
          direction: lang === "ar" ? "rtl" : "ltr",
          textAlign: lang === "ar" ? "right" : "left"
        }}
      >

        {/* LANGUAGE SWITCH */}
        <div style={{ textAlign: "center", marginBottom: "10px" }}>
          <button
            onClick={() => setLang(lang === "en" ? "ar" : "en")}
            style={{
              background: "rgba(0,0,0,0.5)",
              border: "1px solid white",
              padding: "8px 20px",
              borderRadius: "6px",
              color: "white",
              cursor: "pointer",
              fontSize: "1rem"
            }}
          >
            {lang === "en" ? "عربي" : "English"}
          </button>
        </div>

        {/* HEADER */}
        <header
          style={{
            textAlign: 'center',
            padding: '30px 10px',
            fontSize: 'clamp(1.5rem, 5vw, 2rem)',
            fontWeight: 'bold',
            textShadow: '1px 1px 5px rgba(0,0,0,0.7)',
            wordWrap: 'break-word'
          }}
        >
          {t[lang].siteTitle}
        </header>

        {/* SOCIAL LINKS */}
        <nav
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '15px',
            padding: '15px 0',
            fontSize: 'clamp(0.9rem, 3vw, 1rem)'
          }}
        >
          <a href="https://web.facebook.com/theNewAdminstrativeCapital/" target="_blank">{t[lang].links.facebook}</a>
          <a href="https://www.instagram.com/thenewadministrativecapital/" target="_blank">{t[lang].links.instagram}</a>
          <a href="https://www.youtube.com/@Thenewcapital" target="_blank">{t[lang].links.youtube}</a>
          <a href="https://www.tiktok.com/@thenewcapitalofegypt" target="_blank">{t[lang].links.tiktok}</a>
          <a href="https://www.threads.com/@thenewadministrativecapital" target="_blank">{t[lang].links.threads}</a>
          <a href="https://www.snapchat.com/@ousama_elabd" target="_blank">{t[lang].links.snapchat}</a>
          <a href="https://x.com/elabd_ousama" target="_blank">{t[lang].links.x}</a>
        </nav>

        {/* INTRO */}
        <section
          style={{
            textAlign: 'center',
            maxWidth: '95%',
            margin: '20px auto',
            fontSize: 'clamp(1rem, 4vw, 1.1rem)',
            lineHeight: '1.6',
            textShadow: '0px 0px 6px rgba(0,0,0,0.7)',
          }}
        >
          {t[lang].intro}
        </section>

        {/* CONTACT FORM */}
        <section
          style={{
            background: 'rgba(0,0,0,0.6)',
            padding: '20px',
            width: '90%',
            maxWidth: '400px',
            margin: '30px auto',
            borderRadius: '10px',
            boxShadow: '0 0 15px rgba(0,0,0,0.5)',
            boxSizing: 'border-box'
          }}
        >
          <h2
            style={{
              textAlign: 'center',
              marginBottom: '20px',
              fontSize: 'clamp(1.2rem, 5vw, 1.5rem)'
            }}
          >
            {t[lang].consultationTitle}
          </h2>

          <form
            action="https://api.web3forms.com/submit"
            method="POST"
          >
            <input type="hidden" name="access_key" value="f0a2a564-1033-467f-b29e-b702d7e5e5ab" />
            
            <input
              type="text"
              name="name"
              placeholder={t[lang].name}
              required
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '15px',
                borderRadius: '5px',
                border: 'none',
                color: 'black'
              }}
            />

            <input
              type="tel"
              name="mobile"
              placeholder={t[lang].mobile}
              required
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '15px',
                borderRadius: '5px',
                border: 'none',
                color: 'black'
              }}
            />

            <textarea
              name="message"
              placeholder={t[lang].message}
              required
              rows="4"
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '15px',
                borderRadius: '5px',
                border: 'none',
                color: 'black'
              }}
            />

            <button
              type="submit"
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#007bff',
                border: 'none',
                color: 'white',
                fontSize: 'clamp(0.9rem, 3vw, 1rem)',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              {t[lang].send}
            </button>
          </form>

          {/* WHATSAPP BUTTON — ONE ICON ONLY */}
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <p style={{ marginBottom: '10px' }}>{t[lang].or}</p>

            <a
              href="https://wa.me/message/QB5OPRCZYMR6H1"
              target="_blank"
              style={{
                display: 'inline-block',
                background: '#25D366',
                padding: '10px 20px',
                borderRadius: '50px',
                textDecoration: 'none',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '1rem'
              }}
            >
              <img 
                src={process.env.PUBLIC_URL + '/images/whatsapp.png'} 
                alt="WhatsApp" 
                style={{ width: '28px', verticalAlign: 'middle', marginRight: '10px' }}
              />
              WhatsApp
            </a>
          </div>
        </section>

        {/* SHARE */}
        <section style={{ textAlign: 'center', marginTop: '30px' }}>
          <h2 style={{ marginBottom: '15px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>{t[lang].share}</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '15px' }}>
            <FacebookShareButton url={shareUrl} quote={t[lang].seoTitle}>
              <FacebookIcon size={48} round />
            </FacebookShareButton>

            <TwitterShareButton url={shareUrl} title={t[lang].seoTitle}>
              <TwitterIcon size={48} round />
            </TwitterShareButton>

            <WhatsappShareButton url={shareUrl} title={t[lang].seoTitle}>
              <WhatsappIcon size={48} round />
            </WhatsappShareButton>

            <LinkedinShareButton url={shareUrl} title={t[lang].seoTitle}>
              <LinkedinIcon size={48} round />
            </LinkedinShareButton>
          </div>
        </section>

      </div>
    </>
  );
}

export default App;
